import GlobirdSelectorOption from 'data/GlobirdSelectorOption';

const menuOptions: GlobirdSelectorOption<string>[] = [
    { name: "FAQs", value: "faq" },
    { name: "Contact us", value: "assistance" },
    { name: "Self Serve Forms", value: "selfserveform" },
    { name: "Request a call-back", value: "callback" }
];
export default menuOptions;